import * as rd from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { SpotType } from '@/models/cart.ts'
import { cartSlice } from '..'

export const cartDetailReservationsSelector = createSelector(
  [cartSlice.selectors.cartDetail],
  (cartDetail) => {
    if (!rd.isSuccess(cartDetail)) {
      return []
    }

    return cartDetail.value.cart.reservationModels.map((model) => ({
      beds: model.beds,
      boughtServices: [],
      chairs: model.chairs,
      deckChairs: model.deck_chairs,
      endDate: model.end_date,
      halfDay: model.half_day,
      maxiBeds: model.maxi_beds,
      notes: model.notes,
      seasonal: model.seasonal,
      sectorId: model.sector?.id,
      sectorName: model.sector?.name,
      shouldShowSpotName: model.shouldShowSpotName,
      spotName: model.spot_name,
      spotType: model.spot_type as SpotType,
      startDate: model.start_date,
    }))
  }
)
